@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="d-flex flex-column justify-content-center p-2">
        <app-detail-info-card [data]="address" [disableShadow]="true"></app-detail-info-card>
    </div>
}